import React, { useState } from 'react';

import { graphql } from 'gatsby';

import Hero from '../components/Hero';
import Layout from '../components/Layout';
import PriceBox from '../components/PriceBox';

function Pricelist({ data }) {
    const [ openTab, setOpenTab ] = useState(1);
    const prices = data.allMarkdownRemark.nodes;
    return (
        <Layout>
            <Hero text={'Unsere Preise'} />
            <div id="price-list-content" className="container mx-auto px-4">
                <div className="flex justify-center space-x-4 py-8"> 
                    <button
                        className={openTab === 1 ? 'text-red-500' : 'text-gray-800'}
                        onClick={() => {
                            setOpenTab(1);
                        }}
                    >
                        Damen
                    </button>
                    <button
                        className={openTab === 2 ? 'text-red-500' : 'text-gray-800'}
                        onClick={() => {
                            setOpenTab(2);
                        }}
                    >
                        Herren
                    </button>
                    <button
                        className={openTab === 3 ? 'text-red-500' : 'text-gray-800'}
                        onClick={() => {
                            setOpenTab(3);
                        }}
                    >
                        Kinder
                    </button>
                </div>
                <div className="w-full h-full shadow-md rounded p-4 text-gray-800">
                    <span className={openTab === 1 ? 'block' : 'hidden'}>
                        <div className="flex flex-col space-y-4">
                            {prices.map((item, index) => {
                                return (
                                    item.parent.relativeDirectory === 'women'
                                        ? <PriceBox key={index} label={item.frontmatter.label} description={item.frontmatter.description} price={item.frontmatter.price} />
                                        : null
                                )
                            })}
                        </div>
                    </span>
                    <span className={openTab === 2 ? 'block' : 'hidden'}>
                    <div className="flex flex-col space-y-4">
                            {prices.map((item, index) => {
                                return (
                                    item.parent.relativeDirectory === 'men'
                                        ? <PriceBox key={index} label={item.frontmatter.label} description={item.frontmatter.description} price={item.frontmatter.price} />
                                        : null
                                )
                            })}
                        </div>
                    </span>
                    <span className={openTab === 3 ? 'block' : 'hidden'}>
                    <div className="flex flex-col space-y-4">
                            {prices.map((item, index) => {
                                return (
                                    item.parent.relativeDirectory === 'kids'
                                        ? <PriceBox key={index} label={item.frontmatter.label} description={item.frontmatter.description} price={item.frontmatter.price} />
                                        : null
                                )
                            })}
                        </div>
                    </span>
                </div>
            </div>
        </Layout>
    );
}

export default Pricelist;

export const query = graphql`
query Pricelist {
    allMarkdownRemark {
      nodes {
        frontmatter {
          description
          label
          name
          price
          service
        }
        parent {
          ... on File {
            name
            relativeDirectory
          }
        }
      }
    }
  }
`